import { render } from "./Training.vue?vue&type=template&id=39a0e3c2&scoped=true"
import script from "./Training.vue?vue&type=script&lang=js"
export * from "./Training.vue?vue&type=script&lang=js"

import "./Training.vue?vue&type=style&index=0&id=39a0e3c2&lang=scss&scoped=true"

import exportComponent from "/root/Fnedu/build/build20221128.131745/dashboard/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39a0e3c2"]])

export default __exports__